var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeChef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_8407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3575 12.7881H2.64526V14.5542H12.3575V12.7881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5237 2.17241C11.2064 2.17241 10.8955 2.21451 10.5949 2.2978C10.339 1.81273 9.97166 1.39522 9.51647 1.07554C8.92989 0.663564 8.23972 0.445801 7.5206 0.445801C6.79825 0.445801 6.10553 0.665351 5.51733 1.08072C5.06215 1.4022 4.69559 1.82129 4.44094 2.30785C4.12937 2.21782 3.8064 2.17238 3.47625 2.17238C1.55944 2.17241 0 3.73188 0 5.64869C0 7.26049 1.11272 8.64884 2.64507 9.02481V11.9073H12.3573V9.02419C13.8882 8.64726 15 7.25908 15 5.64866C15 3.73188 13.4406 2.17241 11.5237 2.17241Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_8407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeChef);
export default __webpack_public_path__ + "static/media/HomeChef.a6ea7c1607f5fd47d9a68dfb1a30816d.svg";
export { ForwardRef as ReactComponent };